import { RouterProvider } from 'react-router-dom'

import { useInitAuth } from '@/hooks/useInitAuth'
import router from '@/router'

export default function App() {
  const { authStatus } = useInitAuth()

  // 토큰 시도 중엔 빈 화면 — 비회원이어도 짧은 loading만 거치고 ready 됨 (timeout 5s 내)
  if (authStatus === 'loading') return null

  return <RouterProvider router={router} />
}
